import React, { useEffect, useState, FC } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
//import { FormItem } from './useInterfaces/FormInterfeses';
import * as types from "../gql/graphql";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Paper, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AddIcon from '@mui/icons-material/Add';

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Card from "@mui/material/Card";

import { styled, lighten, darken } from '@mui/system';

import { SubmitErrorHandler, SubmitHandler, useForm, Controller } from 'react-hook-form';

//import "primereact/resources/themes/md-light-indigo/theme.css";

import MDBoxRoot from './MDBox/MDBoxRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import { SchoolTime } from '../utils/SchoolTime';
import { useQueryAll } from '../apolloClient';

const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    textTransform: "capitalize",
    backgroundColor:
        theme.palette.mode === 'light'
            ? lighten(theme.palette.primary.light, 0.85)
            : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled('ul')(({ theme }) => ({
    padding: 0,
    color: theme.palette.primary.main,
    //color:"black"
}));


interface EditStudentDialogProps {
    StudentID: number;
}

const getStudentAttendanceQuery = gql(`
    query GetStudentAttendanceQuery($filter: fs_attendancehistoryFilter) {
      fs_attendancehistoryCollection(filter: $filter) {
      edges {
        node {
          nodeId
          id
          class
          classname
          datetaken
          student
          event
        }
      }
    }
  }
`);


const deleteStudentAttendanceQuery = gql(`
  mutation DeleteStudentAttendanceMutation($filter: fs_attendancehistoryFilter) {
    deleteFromfs_attendancehistoryCollection(filter: $filter) {
		      affectedCount
    }
  }
`);

const addStudentAttendanceQuery = gql(`
    mutation AddStudentAttendanceMutation($ah: fs_attendancehistoryInsertInput!) {
        insertIntofs_attendancehistoryCollection(objects: [$ah]) {
            affectedCount
            records {
                nodeId
                id
                class
                classname
                datetaken
                student
                event
            }            
        }
    } 
  `
);

const getClassesForHistory = gql(`
    query GetClassesForHistory($after: Cursor) {
      fs_classesCollection(after: $after) {
          pageInfo { endCursor startCursor hasNextPage }
          edges {
            node {
              nodeId
              id
              name
            }
          }
        }
    }
`);


interface AttendanceProps {
    StudentID: number;
}

const StudentAttendance: FC<AttendanceProps> = (props) => {

    const { data, error, loading, refetch } = useQuery<types.GetStudentAttendanceQueryQuery>(getStudentAttendanceQuery, { variables: { filter: { student: {eq: props.StudentID }}}, fetchPolicy: 'network-only' });


    const [deleteStudentAttendanceMutation, { loading: deleteStudentAttendanceLoading, error: deleteStudentAttendanceError }] = useMutation(deleteStudentAttendanceQuery, {
        refetchQueries: [
            'GetStudentAttendanceQuery'// Query name
        ],
    });

    const [addStudentAttendancMutation, { loading: addStudentAttendanceLoading, error: addStudentAttendanceError }] = useMutation(addStudentAttendanceQuery, {
        refetchQueries: [
            'GetStudentAttendanceQuery'// Query name
        ],
    });

    const { data: Cdata } = useQueryAll<types.Fs_ClassesEdge>({query: getClassesForHistory});

    // Prepare list of classes and packages for new purchases
    var classesForHistory = [];
    classesForHistory = Cdata?.map(edge => ({
        value: edge.node.id,
        label: edge.node.name,
    }));

    const [isClassModalOpen, setIsClassModalOpen] = useState<boolean>(false);

    const handleAttendanceRecordDelete = (record) => {
        deleteStudentAttendanceMutation({ variables: { filter: { id: { eq: record } } } });
    }


    const handleAddAttendanceRecord = (record) => {
        {
            addStudentAttendancMutation({ variables: { ah: { class: record.value, classname: record.label, student: props.StudentID } } });
            setIsClassModalOpen(false);
        };
    }


    if (loading) return (<div>Loading</div>)
    if (error) return (<div>Error</div>)

    function comp_func(option, value) {
        return option.id == value.id;
    }

    return (
        <Card sx={{ marginTop: "10px", padding: "4px 16px 8px" }}>
            <MDBoxRoot ownerState={{
                variant: "contained",
                bgColor: "secondary",
                coloredShadow: "secondary",
            }}
                borderRadius={2}
                sx={{ display: 'flex', width: '100%' }} pb={1} px={2} mt={-1} >
                <MDTypographyRoot variant="h3" ownerState={{ color: "white" }}>
                    Attendance History
                </MDTypographyRoot>
            </MDBoxRoot>

            <MDBoxRoot
                px={0} py={2} textAlign="right"
            >
                <MDButtonRoot
                    ownerState={{
                        size: "medium",
                        variant: "text",
                        color: "info",
                        textTransform: "uppercase",
                    }}
                    startIcon={<AddIcon />}
                    onClick={() => { setIsClassModalOpen(true); /*classReset({ number: 1 }); */}}>
                    Add Class as Attended
                </MDButtonRoot>
            </MDBoxRoot>

            <MDBoxRoot component="table" sx={{ borderSpacing: "0px" }} mt={3}>
                <MDBoxRoot component="thead" ownerState={{
                    variant: "contained",
                    bgColor: "light"
                }}
                    borderRadius={2}>
                    <MDBoxRoot component="tr" >
                        <MDBoxRoot component="td" textAlign="left" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Class
                            </MDTypographyRoot>
                        </MDBoxRoot>
                        <MDBoxRoot component="td" textAlign="left" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Date
                            </MDTypographyRoot>
                        </MDBoxRoot>
                        <MDBoxRoot component="td" textAlign="center" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Delete
                            </MDTypographyRoot>
                        </MDBoxRoot>
                    </MDBoxRoot>
                </MDBoxRoot>

                <MDBoxRoot component="tbody">
                    {data.fs_attendancehistoryCollection.edges.map((record) => (
                        <MDBoxRoot component="tr" key={record.node.id}>
                            <MDBoxRoot component="th" ownerState={{ scope: "row" }} textAlign="left">
                                <MDTypographyRoot variant="h5"
                                    ownerState={{
                                        color: "inherit",
                                        fontWeight: "medium"
                                    }}>
                                    {record.node.classname}
                                </MDTypographyRoot>
                            </MDBoxRoot>
                            <MDBoxRoot component="td" textAlign="left">
                                <MDTypographyRoot variant="h5"
                                    ownerState={{
                                        color: "inherit",
                                        fontWeight: "regular"
                                    }}>
                                    {(record.node.datetaken)? (SchoolTime.fromISO(record.node.datetaken))?.toDateTime().toFormat("D"):"N/A"}
                                </MDTypographyRoot>
                            </MDBoxRoot>
                            <MDBoxRoot component="td" textAlign="center">
                                <IconButton aria-label="Delete" onClick={() => { handleAttendanceRecordDelete(record.node.id); }}>
                                    <DeleteIcon />
                                </IconButton>
                            </MDBoxRoot>
                        </MDBoxRoot>
                    ))}
                </MDBoxRoot>
            </MDBoxRoot>


            <Dialog
                maxWidth="md"
                fullWidth={true}
                open={isClassModalOpen}
                onClose={() => setIsClassModalOpen(false)}>
                <MDTypographyRoot variant="h5" px={1} py={1}>Adding as attended <CloseIcon onClick={() => setIsClassModalOpen(false)} sx={{ position: "absolute", top: "10px", right: "10px" }} /></MDTypographyRoot>
                <DialogContent dividers>
                    <Autocomplete
                        fullWidth={true}
                        options={classesForHistory}
                        onChange={(e, sel) => handleAddAttendanceRecord(sel)}
                        renderInput={(params) => (
                            <MDInput {...params} label="Select" variant="outlined" />
                        )}
                    />
                </DialogContent>
            </Dialog>
        </Card>
    )
}

export default StudentAttendance;




